import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BLOG_POSTS } from '../mock';
import { Card } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Input } from '../components/ui/input';
import { Search } from 'lucide-react';

const Blog = () => {
  const [q, setQ] = useState('');
  const [cat, setCat] = useState('Alle');
  const cats = ['Alle', ...new Set(BLOG_POSTS.map(p => p.category))];
  const filtered = BLOG_POSTS.filter(p =>
    (cat === 'Alle' || p.category === cat) &&
    (!q || p.title.toLowerCase().includes(q.toLowerCase()) || p.excerpt.toLowerCase().includes(q.toLowerCase()))
  );

  return (
    <div>
      <section className="hero-gradient text-white py-16">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <h1 className="text-4xl md:text-5xl font-bold">Kennisbank</h1>
          <p className="text-slate-200 mt-4">Actuele blogs over bezwaarprocedures, boetes en verkeersrecht.</p>
          <div className="mt-6 relative max-w-xl">
            <Search className="w-5 h-5 absolute left-4 top-3.5 text-slate-500" />
            <Input value={q} onChange={e => setQ(e.target.value)} placeholder="Zoek artikelen..." className="pl-11 h-12 bg-white text-slate-900 border-0" />
          </div>
        </div>
      </section>
      <section className="py-12 max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-wrap gap-2 mb-8">
          {cats.map(c => (
            <button key={c} onClick={() => setCat(c)}
              className={`px-4 py-1.5 rounded-full text-sm font-medium border transition-colors ${cat === c ? 'bg-[#1e1b4b] border-[#1e1b4b] text-white' : 'bg-white border-slate-200 text-slate-700 hover:border-[#1e1b4b]'}`}>
              {c}
            </button>
          ))}
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map(p => (
            <Link key={p.slug} to={`/blog/${p.slug}`} className="card-hover">
              <Card className="overflow-hidden border border-slate-200 h-full">
                <div className="h-48 bg-slate-100 overflow-hidden">
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover" />
                </div>
                <div className="p-5">
                  <Badge className="bg-[#f26b1f]/10 text-[#f26b1f] border-0 hover:bg-[#f26b1f]/15">{p.category}</Badge>
                  <div className="font-bold text-[#1e1b4b] mt-3 leading-snug">{p.title}</div>
                  <div className="text-sm text-slate-600 mt-2 line-clamp-2">{p.excerpt}</div>
                  <div className="text-xs text-slate-400 mt-3">{p.date} • {p.readTime} • {p.author}</div>
                </div>
              </Card>
            </Link>
          ))}
          {!filtered.length && <div className="text-slate-500">Geen artikelen gevonden.</div>}
        </div>
      </section>
    </div>
  );
};

export default Blog;
